const generateBasicCardBlock = (title, date, imageUrl) => {
	const template = document.querySelector('._template-block > .card-block').cloneNode(true);

	template.lastChild.lastChild.innerText = title;
	template.lastChild.firstChild.innerText = date;
	template.firstChild.setAttribute(
		'style',
		`background-image: url(${imageUrl})`,
	);

	return template;
};

export default generateBasicCardBlock;



// WEBPACK FOOTER //
// ./src/js/about/generateBasicCardBlock.js